import IGeoCoordinate from "./IGeoCoordinate";

export class GeoCoordinate implements IGeoCoordinate {
    static kmInMile: number = 1.61;

    static mileToKm(miles: number): number {
        return miles * GeoCoordinate.kmInMile;
    }

    static getDistance(p1: IGeoCoordinate, p2: IGeoCoordinate) {
        const tolerance = 0.00001; // ~1.1m precision
        if (Math.abs(p1.longitude - p2.longitude) < tolerance && Math.abs(p1.latitude - p2.latitude) < tolerance)
            return 0;

        const earthRadiusInMiles = 3960;

        const degToRad = (Math.PI / 180);
        const f1 = p1.latitude * degToRad;
        const f2 = p2.latitude * degToRad;

        const dLon = (p2.longitude - p1.longitude) * degToRad;

        const c = Math.acos(Math.sin(f1) * Math.sin(f2) + Math.cos(f1) * Math.cos(f2) * Math.cos(dLon));

        return earthRadiusInMiles * c;
    }

    constructor(public latitude: number,
        public longitude: number) {
        this.latitude = latitude;
        this.longitude = longitude;
    }
}